/** Server `AiAgent.OUTFITTER_ASSISTANT` (use until GraphQL codegen adds the enum). */
export const OUTFITTER_ASSISTANT_AGENT = "OUTFITTER_ASSISTANT" as const

/** Matches server `visualContext.mode` when no UI summary is sent. */
export const OUTFITTER_ASSISTANT_VISUAL_CONTEXT_MODE_NONE = "none" as const

/** `visualContext.mode` when we attach a text outline of the current page. */
export const OUTFITTER_ASSISTANT_VISUAL_CONTEXT_MODE_UI_SUMMARY =
    "ui_summary" as const

/** Fixed width of the desktop assistant side pane. */
export const ASSISTANT_PANE_WIDTH = "440px" as const

/** Matches the header ButtonGroup gap so the collapsed pill removes its own gap. */
export const ASSISTANT_HEADER_BUTTON_GAP = "10px" as const

/** Upper bound for the divider + pill while animating max-width. */
export const ASSISTANT_HEADER_BUTTON_MAX_WIDTH = "200px" as const

/** Max entries retained in the per-turn navigation breadcrumb trail. */
export const OUTFITTER_ASSISTANT_HISTORY_CAP = 8 as const

/** Number of persisted Susie chats loaded in each history page. */
export const OUTFITTER_ASSISTANT_CONVERSATION_HISTORY_PAGE_SIZE = 20 as const

/** Number of persisted messages restored when a Susie chat is opened. */
export const OUTFITTER_ASSISTANT_CONVERSATION_MESSAGE_PAGE_SIZE = 100 as const

/** Upper bound on the serialized page outline, in characters (~3K tokens). */
export const OUTFITTER_ASSISTANT_SNAPSHOT_CHAR_CAP = 12_000 as const

/** Applied to a subtree to cut it out of the page outline entirely. */
export const OUTFITTER_ASSISTANT_EXCLUDE_ATTR =
    "data-assistant-exclude" as const

/** Applied to a form field to mask its value (label is still emitted). */
export const OUTFITTER_ASSISTANT_REDACT_ATTR = "data-assistant-redact" as const

export type OutfitterAssistantAgent = typeof OUTFITTER_ASSISTANT_AGENT
